import React from 'react'
import { ListGroup } from 'react-bootstrap'
import PlayerTeamListItem from '../PlayerTeamListItem'
import * as s from './YouMayRememberMeAs.scss'

const PlayoffTeamInfo = ({ playoffStatus = null, isLeagueChampion = false, isLeagueRunnerUp = false, isPlayoffTeam = false, maxPlayoffWeek = 0 }) => (
    playoffStatus ?
    <span className={s.playoffStatus + (isLeagueChampion ? ` ${s.leagueChampion}` : '') + (isLeagueRunnerUp ? ` ${s.leagueRunnerUp}` : '')}>{playoffStatus}</span>
    : null
)

const YouMayRememberMeAs = ({ youMayRememberMeAs = [] }) => {

    const ymrma = youMayRememberMeAs
    return (
        <div className={s.container}>
            <h3>Team history</h3>
            <ListGroup variant='flush'>
            {ymrma && ymrma.map(i => 
                <PlayerTeamListItem key={`ymrma-${i.teamId}`}
                    size='sm'
                    teamId={i.teamId} 
                    teamName={i.teamName} teamNameRaw={i.teamName}
                    avatarUrl={i.avatarUrl}
                    miniHeader={<div>{i.seasonName}</div>}
                    right={<div>{i.record}</div>}
                    detail={<PlayoffTeamInfo {...i} />} />
            )}
            </ListGroup>
        </div>
    )
}

export default YouMayRememberMeAs
